module.exports = __webpack_public_path__ + "media/svg/nc-2ebfe259.svg";